import { css } from '@emotion/core'
import { mq, NavBottomPadding, NavH, preventScrollStyle, ShowAni } from '@styles/base.style'
import styled, { Theme } from '@themes/theme'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'

export const SearchWrap = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 0 14px 12px;
  background:${props => props.theme.color.themeTxt};
  .ant-input {
    height: 42px;
    padding: 3px 0 3px 18px;
    font-size: ${props => props.theme.font.medium};
    line-height: 4.2rem;
    color: ${props => props.theme.color.mainBg};
    background: #FFFFFFB3 !important;
    transition: all 0.3s;
    border-radius: 50px;
    border: none;
    &:hover,
    &:focus,
    &:active {
      border: none !important;
      box-shadow: none !important;
      & + .ant-input-suffix .ant-input-search-icon {
        color: ${props => props.theme.color.modalyellow};
      }
    }
  }
  .ant-input-search {
    &:hover + .clear-btn,
    &:focus + .clear-btn,
    &:active + .clear-btn {
      display: block;
      svg {
        animation: ${ShowAni} 0.3s forwards;
      }
    }
  }
  .ant-input-suffix {
    right: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    .ant-input-clear-icon {
      font-size: ${props => props.theme.font.largeNum};
    }
  }
  .ant-input-search-enter-button + .ant-input-group-addon {
    padding: 4px 6px;
    background: #FFFFFFB3;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    .ant-input-search-button {
      width: 58px;
      height: 34px;
      background: ${props => props.theme.color.subBg};
      border-radius: 50px !important;
      border: none;
      &::after {
        box-shadow: none !important;
      }
    }
  }
  &.pc-search-wrap {
    margin-bottom: -1px;
    padding-top: 14px;
  }
  &.white-search {
    .ant-input::placeholder {
      color: ${props => props.theme.color.modalDarkBg};
    }
  }
`
export const ClearBtnStyle = (theme: Theme) => css`
  display: none;
  position: absolute;
  width: 14px;
  top: 50%;
  right: 13px;
  padding: 3px 10px;
  background: none;
  transition: all 0.3s;
  transform: translate(0, -50%);
  &::before {
    display: none;
  }
  svg {
    position: relative;
    top: 1px;
    right: 2px;
    transition: all 0.3s;
    transform: rotate(45deg);
    path {
      fill: ${theme.color.primary};
    }
  }
`
export const ClearStyle = css`
  width: 14px;
`
export const BettorListWrap = styled.article`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${props => props.theme.color.themeTxt};
  .am-list-view-scrollview {
    width: 100%;
    min-height: calc(100vh - 41px - 46px - 54px - 40px - ${NavH} + 4px); // 로고 - 헤더 - 검색 - 탭 - 내비 + paddingTop
    padding-top: 4px;
    ${preventScrollStyle};
    .am-list-body {
      background: none;
      .ant-list-item {
        justify-content: space-between;
        align-items: center;
        height: 64px;
        padding: 0 14px;
        border-bottom: 1px solid ${props => props.theme.color.modalSubBg2};
        background: ${props => props.theme.color.themeTxt};
      }
    }
    .am-list-footer {
      padding-bottom: ${NavBottomPadding};
    }
  }
  &.isAndroidAppKeyboardVisible {
      .am-list-view-scrollview{
          min-height: calc(100vh);       
      }
  }
  &:not(.pc) {
    .am-list-view-scrollview {
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  &.pc {
    .am-list-view-scrollview {
      min-height: calc(100% - 108px);
      .am-list-body {
        padding-bottom: 0;
      }
    }
  }
`
export const BettorWrap = styled.div`
  position: relative;
  top: 1px;
  flex: 1;
  display: inline-flex;
  align-items: center;
  .bettor-name {
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
  }
  .bettor-bet-money {
    color: ${props => props.theme.color.modalSubTxt};
    font-size: ${props => props.theme.font.medium};
  }
  .user-profile-btn {
    margin-right: 10px;
    .profile-img-wrap {
      ${ProfileImgWrapStyle};
      width: 36px;
      height: 36px;
    }
    .online-status {
      position: absolute;
      bottom: -3px;
      right: -3px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #00DE34;
      border: 3px solid ${props => props.theme.color.modalBg};
      box-sizing: content-box;
    }
  }
`
export const BettorImgStyle = css`
  position: relative;
  top: -1px;
  width: 18px;
  margin-right: 6px;
  ${mq[0]} {
    display: none;
  }
`
export const ButtonWrap = styled.div`
  text-align: right;
  .message {
    position: relative;
    &--time-info {
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(calc(-50% - 10px));
      color: ${props => props.theme.color.modalDarkBg};
      white-space: nowrap;
    }
  }
`
// 베팅권 보내기, 하트 보내기, 메시지 보내기 버튼
export const BtnStyle = (theme: Theme) => css`
  display: inline-block;
  width: 44px;
  height: 44px;
  margin-left: 10px;
  text-indent: 0.4rem;
  font-size: ${theme.font.small};
  svg {
    position: relative;
    top: 2px;
    right: 4px;
    width: 34px;
    height: auto;
  }
  // 베팅권 선물하기 버튼
  &.bet-coupon {
    svg {
      top: 1px;
    }
  }
  // 하트 선물하기 버튼
  &.heart {
  }
  // 메세지 보내기 버튼
  &.message {
  }
`
export const BettorFindRefreshBtn = (theme: Theme) => css`
  position: absolute;
  top: 2px;
  right: 8px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    width: 13px;
    height: auto;
    transform: translateY(-1px);
    path {
      fill: ${theme.color.mainBg};
    }
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: -20px;
    transform: translateY(-50%);
    width: 20px;
    height: 39px;
    background: linear-gradient(270deg, #EEEEEE 0%, rgba(238, 238, 238, 0) 100%);
  ;
  }
`
